import {svgIconWrapper} from '../svg-icon-wrapper';

import DropboxRegular from './dropbox-regular-icon.svg';

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
    return <DropboxRegular {...props} />;
}

SvgComponent.iconName = 'dropboxRegular';

export const DropboxRegularIcon = svgIconWrapper(SvgComponent);
